
import { defineComponent } from 'vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';

export default defineComponent({
  name: 'OffCanvasBody',
});
